import React, { useState, useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";


import "./Resume.css";

const Resume = (props) => {
  /* STATES */
  const [selectedBulletIndex, setSelectedBulletIndex] = useState(0);
  const [carousalOffsetStyle, setCarousalOffsetStyle] = useState({});

  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;

    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

/* REUSABLE MINOR COMPONENTS */
const ResumeHeading = (props) => {
  return (
    <div className="resume-heading">
      <div className="resume-main-heading">
        <div className="heading-bullet"></div>
        {props.link ? (
          <div className="project-head-container">
             <span className={props.projectTitleClass}>
                {props.heading}
              </span>
              <a href={props.link}>View Project</a>
          </div>
         
        ) : (
          <span className={props.projectTitleClass}>
            {props.heading}
          </span>
        )}
        {props.fromDate && props.toDate ? (
          <div className="heading-date">
            {props.fromDate + "-" + props.toDate}
          </div>
        ) : (
          <div></div>
        )}
      </div>
      <div className="resume-sub-heading">
        <span>{props.subHeading}</span>
      </div>
      <div className="resume-heading-description">
        <span>{props.description}</span>
        
        {props.bull && props.bull.map((bullet, index) => (
          <ul key={index}>
           <li>{bullet}</li>
          </ul>
        ))}

      </div>
    </div>
  );
};




  /* STATIC RESUME DATA FOR THE LABELS*/
  const resumeBullets = [
    { label: "WavJam", logoSrc: "music-note-svgrepo-com.svg" },
    { label: "binayBash", logoSrc: "party-horn-svgrepo-com.svg" },
    { label: "Bunny Invasion", logoSrc: "bunny-rabbit-svgrepo-com.svg" },
    { label: "Article Summarizer", logoSrc: "ai-mi-algorithm-svgrepo-com.svg" },
  ];

  //here we have
  const programmingSkillsDetails = [
    { skill: "HTML/CSS", ratingPercentage: 90 },
    { skill: "TailwindCSS", ratingPercentage: 80},
    { skill: "Material-UI", ratingPercentage: 80},
    { skill: "JavaScript", ratingPercentage: 75 },
    { skill: "React JS", ratingPercentage: 70 },
    { skill: "Node JS", ratingPercentage: 45 },
    { skill: "Python", ratingPercentage: 70},
    { skill: "Flask", ratingPercentage: 70},
    { skill: "SQLAlchemy", ratingPercentage: 0},
    { skill: "mySQL", ratingPercentage: 70},
    { skill: "SQLite", ratingPercentage: 70},
    { skill: "PostgreSQL", ratingPercentage: 0},
    { skill: "OOP", ratingPercentage: 0},
    { skill: "ORM", ratingPercentage: 0},
    { skill: "Restful APIs", ratingPercentage: 0},
    { skill: "Git", ratingPercentage: 0},
    { skill: "Github", ratingPercentage: 0},
  ];

  const projectsDetails = [
    {
      title: "WavJam",
      duration: {},
      description:
        "A social platform for musicians for it's sole purpose to unite musicians to collaborate in harmony in the easiet and fastest way.",
      subHeading: "Technologies Used: Vite, React, Python, Flask, SQLAlchemy, PostgreSQL, Auth",
      link: "https://github.com/miguel4prez/wavjam",
      bull: [
        'Spearheaded the migration to PostgreSQL, enhancing data storage efficiency and scalability, resulting in a 30% decrease in database maintenance costs and supporting a 60% increase in data processing speed.', 
        'Developed and maintained RESTful API endpoints using Flask to handle user-related functionalities such as user retrieval, signup, login, and logout.',
        'Ensured accessibility by incorporating labels and proper input field associations, enhancing the user experience for individuals using assistive technologies.'
      ]
    },
    {
      title: "binaryBash",
      duration: {},
      description:
        "Inspired by the mobile app 'Partiful', a web application for software developers to plan events. ",
      subHeading:
        "Technologies Used: React, Python, Flask, SQLAlchemy, SQLite, Auth",
      link: "https://github.com/miguel4prez/binaryBash",
      bull: [
        'Developed Python classes with properties and validations, establishing one-to-many and many-to-many relationships.', 
        'Implemented a secure user authentication system using Flask, SQLAlchemy, and bcrypt.',
        'Utilized Flask and SQLAlchemy to interact with an SQLite database, ensuring optimal data organization and retrieval.'
      ]
    },
    {
      title: "Bunny Invasion",
      duration: {},
      description:
        "A 2D platformer game using the Pygame library in Python.",
      subHeading:
        "Technologies Used: Python, Pygame",
      link: "https://github.com/miguel4prez/binaryBash",
      bull: [
        'Implemented a modular and organized code structure by creating a class to encapsulate player and enemy attributes, fostering code reusability and maintainability.', 
        'Programmed an enemy AI system for automatic movement and shooting, with random idling behavior.',
        "Developed a system to dynamically load and display characters, items, obstacles, and decorations based on their file index using Python’s CSV module."
      ]
    },
    {
      title: "Article Summarizer - OpenAI",
      duration: {},
      description: "An article summarizer application, just paste your link!",
      subHeading: "Technologies Used: Javascript, RapidAPI, Redux, TailwindCSS, Vite",
      link: "https://sumzarticles-openai.netlify.app",
      bull: [
        'Leveraged Redux and its toolkit for efficient global state management, configuring a Redux store to handle API-related state and actions seamlessly.', 
        'Integrated the RapidAPI platform into the application to access and utilize external services for article extraction and summarization functionalities.',
        'Utilized lazy loading techniques for API requests to optimize data fetching processes and minimize unnecessary network traffic, enhancing application performance.',
        "Configured an API client using '@reduxjs/toolkit/query/react' to interact with external services, facilitating seamless data retrieval and manipulation."
      ]
  }
  ];

  // const projectOneBull = projectsDetails[0].bull.map((bullet, index) => {

  // })

const resumeDetails = [
  <div className="resume-screen-container" key="education">
    <ResumeHeading
      heading={projectsDetails[0].title}
      subHeading={projectsDetails[0].subHeading}
      bull={projectsDetails[0].bull}
      description={projectsDetails[0].description}
      link={projectsDetails[0].link} // Pass the link as a prop
      projectTitleClass={projectsDetails[0].link ? "project-title" : ""} // Conditionally apply the project-title class
    />

  </div>,

<div className="resume-screen-container" key="projects">

  <ResumeHeading
    heading={projectsDetails[1].title}
    subHeading={projectsDetails[1].subHeading}
    bull={projectsDetails[1].bull}
    description={projectsDetails[1].description}
    link={projectsDetails[1].link} // Pass the link as a prop
    projectTitleClass={projectsDetails[1].link ? "project-title" : ""} // Conditionally apply the project-title class
  />

</div>,

<div className="resume-screen-container" key="projects">
  <ResumeHeading
    heading={projectsDetails[2].title}
    subHeading={projectsDetails[2].subHeading}
    bull={projectsDetails[2].bull}
    description={projectsDetails[2].description}
    link={projectsDetails[2].link} // Pass the link as a prop
    projectTitleClass={projectsDetails[2].link ? "project-title" : ""} // Conditionally apply the project-title class
  />
</div>,

<div className="resume-screen-container" key="projects">
  <ResumeHeading
    heading={projectsDetails[3].title}
    subHeading={projectsDetails[3].subHeading}
    bull={projectsDetails[3].bull}
    description={projectsDetails[3].description}
    link={projectsDetails[3].link} // Pass the link as a prop
    projectTitleClass={projectsDetails[3].link ? "project-title" : ""} // Conditionally apply the project-title class
  />
</div>,

  ];

  const handleCarousal = (index) => {
    let offsetHeight = 360;

    let newCarousalOffset = {
      style: { transform: "translateY(" + index * offsetHeight * -1 + "px)" },
    };

    setCarousalOffsetStyle(newCarousalOffset);
    setSelectedBulletIndex(index);
  };

  const getBullets = () => {
    return resumeBullets.map((bullet, index) => (
      <div
        onClick={() => handleCarousal(index)}
        className={
          index === selectedBulletIndex ? "bullet selected-bullet" : "bullet"
        }
        key={index}
      >
        <img
          className="bullet-logo"
          src={require(`../../assets/Resume/${bullet.logoSrc}`)}
          alt="B"
        />
        <span className="bullet-label">{bullet.label}</span>
      </div>
    ));
  };

  const getResumeScreens = () => {
    return (
      <div
        style={carousalOffsetStyle.style}
        className="resume-details-carousal"
      >
        {resumeDetails.map((ResumeDetail) => ResumeDetail)}
      </div>
    );
  };

  useEffect(() => {
    return () => {
      /* UNSUBSCRIBE THE SUBSCRIPTIONS */
      fadeInSubscription.unsubscribe();
    };
  }, [fadeInSubscription]);

  return (
    <div
      className="resume-container screen-container fade-in"
      id={props.id || ""}
    >
      <div className="resume-content">
        <ScreenHeading title={"Projects"} />
        <div className="resume-card">
          <div className="resume-bullets">
            <div className="bullet-container">
              <div className="bullet-icons"></div>
              <div className="bullets">{getBullets()}</div>
            </div>
          </div>

          <div className="resume-bullet-details">{getResumeScreens()}</div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
